import { render, staticRenderFns } from "./NewAuthority.vue?vue&type=template&id=d8a8335c&scoped=true&"
import script from "./NewAuthority.vue?vue&type=script&lang=js&"
export * from "./NewAuthority.vue?vue&type=script&lang=js&"
import style0 from "./NewAuthority.vue?vue&type=style&index=0&id=d8a8335c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a8335c",
  null
  
)

export default component.exports